import styled from 'styled-components';
import { textEllipsis } from '../../../../../../common/styles/Layout';
import { ThemeColours } from '../../../../../../common/styles/ThemeColours';
import { FONT_STACK, FontWeight } from '../../../../../../common/styles/constants';

export const Subheading = styled.div`
  color: ${ThemeColours.mono900};
  ${FONT_STACK};
  font-size: 10px;
  font-weight: ${FontWeight.BOLD};
  line-height: 12px;
  text-transform: uppercase;
  ${textEllipsis};
`;
